import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { WiseIdAuthServiceManager } from '../../features/sso-wise-id/controller/wise-id-auth.service-manager';
import { UserResult } from '@rfebm/sso-api';



export interface NavbarLink {
  label: string;
  iconPath: string;
  route: string;
}


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements AfterViewInit {

  user: UserResult | null = null;

  /**
   * List of links to be displayed in the navbar.
   */
  navbarLinks: NavbarLink[] = [
    {
      label: 'Análisis',
      iconPath: 'assets/static/icons/graph.svg',
      route: '/analysis',
    },
    {
      label: 'Rendimiento',
      iconPath: 'assets/static/icons/activity.svg',
      route: '/performance',
    },
    {
      label: 'Salud',
      iconPath: 'assets/static/icons/heart.svg',
      route: '/health',
    },
  ]


  constructor(
    private router: Router,
    private wiseIdAuthServiceManager: WiseIdAuthServiceManager,

  ) { }

  ngAfterViewInit(): void {
    this.user = this.wiseIdAuthServiceManager.getUserSessionData();
  }


  /**
   * Método encargado de indicar si nos encontramos en alguna ruta en específico.
   * @param route Ruta a comparar.
   * @returns True si la ruta actual es igual a la ruta pasada por parámetro.
   * @returns False si la ruta actual no es igual a la ruta pasada por parámetro.
   */
  isCurrentRoute(route: string): boolean {
    return this.router.url === route;
  }

}
